<template>
  <v-row justify="center">
    <v-dialog
      max-width="700px"
      :value="isVisible"
      persistent
      @keydown.esc="closeModal"
    >
      <v-card style="background-color: #D9D9D9;">
        <ValidationObserver ref="obs" v-slot="{ invalid }" mode="eager">
          <v-card-title>
            <span class="headline" style="color: #54514C;">{{
              `${updated ? "Edytuj" : "Dodaj"} kurs do warsztatów z taryfami`
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <VTextFieldWithValidation
                    type="text"
                    rules="required"
                    v-model="name"
                    label="Nazwa"
                    color="indigo"
                    outlined
                    dense
                    maxLength="255"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <VTextAreaWithValidation
                    type="text"
                    v-model="description"
                    label="Opis"
                    color="indigo"
                    outlined
                    dense
                    maxLength="2048"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <VTextFieldWithValidation
                    type="text"
                    v-model="videoLink"
                    label="Link YouTube"
                    color="indigo"
                    outlined
                    dense
                    maxLength="1024"
                    rules="link"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <VTextFieldWithValidation
                    type="text"
                    v-model="videoLinkDropbox"
                    label="Link Dropbox"
                    color="indigo"
                    outlined
                    dense
                    maxLength="1024"
                    rules="link"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="label">Taryfa</div>
                  <v-select
                    v-model="sequencingWorkshopId"
                    :items="workshops"
                    item-value="id"
                    item-text="name"
                    outlined
                    color="indigo"
                    dense
                    required
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="label">Typ</div>
                  <v-select
                    v-model="type"
                    :items="types"
                    item-value="id"
                    item-text="name"
                    outlined
                    color="indigo"
                    dense
                    required
                  />
                </v-col>
              </v-row>

              <v-row v-if="!copiedSequencingWorkshopItemId">
                <v-col
                  cols="12"
                  sm="12"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <v-file-input
                    v-model="file"
                    label="Zdjęcie kursu"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#8B857D" text v-on:click="closeModal">
              <font-awesome-icon icon="times" class="mr-1" />
              Anuluj
            </v-btn>
            <v-btn
             color="#8B857D"
              text
              :disabled="invalid"
              v-on:click="addPackageItem"
            >
              <font-awesome-icon icon="check" class="mr-1" />
              Zapisz zmiany
            </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "../inputs/VTextFieldWithValidation";
import VTextAreaWithValidation from "../inputs/VTextAreaWithValidation.vue";

export default {
  name: "AddTariffWorkshopsItemModal",
  props: ["isVisible", "workshopItemData"],

  components: {
    ValidationObserver,
    VTextFieldWithValidation,
    VTextAreaWithValidation,
  },
  mounted() {
    this.$store.dispatch(
      "sequencingWorkshops/fetchSequencingWorkshopWithNotActive",
      { type: "PRICE_TARIFF" }
    );
  },

  data: () => ({
    sequencingWorkshopItemId: null,
    input: "",
    discountError: false,
    updated: false,
    name: "",
    description: "",
    videoLink: "",
    videoLinkDropbox: "",
    file: null,
    sequencingWorkshopId: "",
    imagePath: "",
    copiedSequencingWorkshopItemId: "",
    type: "",
  }),
  updated() {
    if (this.workshopItemData) {
      const {
        id,
        videoLink,
        videoLinkDropbox,
        name,
        description,
        imagePath,
        sequencingWorkshop,
        copy,
        copiedSequencingWorkshopItemId,
        type,
      } = this.workshopItemData;
      this.sequencingWorkshopItemId = id;
      this.updated = true;
      this.name = name;
      this.videoLink = videoLink;
      this.videoLinkDropbox = videoLinkDropbox;
      this.description = description;
      this.imagePath = imagePath;
      this.sequencingWorkshopId = sequencingWorkshop.id;
      this.type = type;
      if (copy) {
        this.updated = null;
        this.copiedSequencingWorkshopItemId = copiedSequencingWorkshopItemId;
      }
    }
  },

  methods: {
    closeModal() {
      this.updated = false;
      this.$emit("closeModal");
      (this.sequencingWorkshopItemId = null),
        (this.input = ""),
        (this.discountError = false),
        (this.updated = false),
        (this.name = ""),
        (this.description = ""),
        (this.videoLink = ""),
        (this.videoLinkDropbox = ""),
        (this.file = null),
        (this.sequencingWorkshopId = ""),
        (this.imagePath = ""),
        (this.copiedSequencingWorkshopItemId = "");
      this.type = "";
    },
    async addPackageItem() {
      let filesAreCorrect = true;

      if (!this.sequencingWorkshopId) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message: "Warsztat do którego ma być przypisany kurs jest wymagany",
        });
        return;
      }
      if (!this.type) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message: "Wybierz typ kursu",
        });
        return;
      }

      if (this.file && !this.file.type.includes("image")) {
        filesAreCorrect = false;
      }

      if (!filesAreCorrect) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message:
            "Niepoprawny format pliku. Dozwolone formaty to: jpg, jpeg, png",
        });
        return;
      }

      let object = {
        name: this.name,
        description: this.description,
        videoLink: this.videoLink,
        videoLinkDropbox: this.videoLinkDropbox,
        file: this.file,
        sequencingWorkshopId: this.sequencingWorkshopId,
        type: this.type,
      };

      if (this.updated) {
        await this.$store
          .dispatch("sequencingWorkshops/updateSequencingWorkshopItem", {
            id: this.sequencingWorkshopItemId,
            data: object,
            type: "PRICE_TARIFF",
          })
          .then(() => {
            this.closeModal();
            this.$emit("updated");
          });
      } else {
        await this.$store
          .dispatch("sequencingWorkshops/addSequencingWorkshopItem", {
            data: object,
            type: "PRICE_TARIFF",
          })
          .then(() => {
            this.closeModal();
            this.$emit("updated");
          });
      }
    },
  },

  computed: {
    workshops() {
      return this.$store.getters["sequencingWorkshops/getSequencingWorkshops"];
    },

    types() {
      return [
        {
          id: "TRAINING",
          name: "Praktyka",
        },
        {
          id: "WORKSHOP_RECORDING",
          name: "Nagranie z warsztatów",
        },

        {
          id: "TRAINING_RECORDING",
          name: "Nagranie z praktyki",
        },
      ];
    },
  },
};
</script>
<style type="scss" scoped>
.outlined-form-section {
  position: relative;

  border-color: rgba(0, 0, 0, 0.38);
  border-width: 2px;
}

.outlined-form-section-title {
  top: -15px;
  left: 10px;
  position: absolute;

  padding: 0.2rem 0.5rem;

  background-color: white;

  font-size: 12px;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
